import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { catchError, filter, switchMap } from "rxjs/operators";
import { throwError } from "rxjs";
import { Router, RouterState } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { environment } from "src/environments/environment";
import { RefreshTokenResponse } from "../api-service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  private state: RouterState;

  constructor(public authService: AuthenticationService, router: Router) {
    this.state = router.routerState;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.authService.getToken()) {
      request = this.addToken(request, this.authService.getToken());
    }

    request = this.addTenant(request, environment.tenantId);

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(request, next);
        } else if (
          error instanceof HttpErrorResponse &&
          error.status === 400 &&
          request.url.includes("refresh")
        ) {
          console.log(this.state);
          this.authService.logout();
        } else {
          return throwError(error);
        }
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  private addTenant(request: HttpRequest<any>, tenant: string) {
    return request.clone({
      setHeaders: {
        Tenant: tenant,
      },
    });
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.renewToken().pipe(
        switchMap((result: RefreshTokenResponse) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(result.token);
          return next.handle(this.addToken(request, result.token));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        //take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }
}
